import { media, Col } from 'ia-react-core';
import styled from 'styled-components';

export const StyledCol = styled(Col)<{ isallnews: string }>`
  margin-bottom: 16px;
  :last-child {
    margin-bottom: 0px;
  }
  ${media.lg <{ isallnews: string }>`
      margin-bottom: 0px;
      ${({ isallnews }) => isallnews === 'true' && `
      margin-bottom: 16px;
      :last-child {
        margin-bottom: 16px;
      }
  `}
  `}
`;
